
AOS.init({
  once: true // Animation will happen only once
});



// A $( document ).ready() block.
$( document ).ready(function() {
  $(".slider_coll").slick({
   slidesToShow: 11,
   infinite:false,
   slidesToScroll: 1,
   autoplay: false,
   arrows: true,
   responsive: [
      {
        breakpoint: 1401,
        settings: {
          slidesToShow: 9,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 7,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 5,
        }
      },
       {
        breakpoint: 479,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
  });

});



var swiper = new Swiper(".Explore_more_main", {
  slidesPerView: 1.3,
  spaceBetween: 0,
    loop: true,
    freeMode: true,
  
  centeredSlides: true, // Centered mode is false for larger screens
  breakpoints: {
        767: {
      slidesPerView: 2.5, // For screens 767px and below, show 1.5 slides
       loop: true,
      centeredSlides: true, // Enable centered mode
      spaceBetween: 0, // Adjust space between slides
    },
    992: {
      slidesPerView: 4, // For screens 767px and below, show 1.5 slides
       loop: false,
      centeredSlides: false, // Enable centered mode
      spaceBetween: 0, // Adjust space between slides
    },
  },
});

document.querySelectorAll('.custom-select').forEach(select => {
    select.addEventListener('click', () => {
        select.querySelector('.custom-options').classList.toggle('active');
    });

    select.querySelectorAll('.custom-option').forEach(option => {
        option.addEventListener('click', () => {
            select.querySelector('.selected-option').textContent = option.dataset.value;
            // Update the actual select value or input as needed
            // Example: update a hidden input field or similar
            // document.getElementById('input-field-id').value = option.dataset.value;

            select.querySelector('.custom-options').classList.remove('active');
        });
    });
});

// Get the select element and the span where the selected value will be shown
var selectElement = document.getElementById('ring_size');
var selectedValueElement = document.querySelector('.selected_value');

// Check if both elements exist
if (selectElement && selectedValueElement) {
  // Set the default selected value on page load
  selectedValueElement.textContent = selectElement.value;

  // Add event listener to update the selected value when a new option is chosen
  selectElement.addEventListener('change', function() {
    selectedValueElement.textContent = this.value;
  });
} else {
  console.error('Required elements are missing in the DOM.');
}



$(document).ready(function() {
    function showSelectedVariantDetails() {
        const selectedVariantId = $('.product-single .single-option-selector input[type=radio]:checked + label').attr('data-var');
        $('.product-fields-table').hide().removeClass('v_act');
        if (selectedVariantId) {
            const targetTable = $(`.product-fields-table[data-var="${selectedVariantId}"]`);
            targetTable.show().addClass('v_act');
        }

        // updateCombinedValues();
    }

    $('.js-product-select-option--2.variants__options .single-option-selector input[type=radio]').on('change', function() {

        showSelectedVariantDetails();

        const selectedValue = $(this).next('label').attr('data-value');


        $('[id="metal-color-details"]').each(function() {
           $(this).text(selectedValue);
        });
    });


    $('.js-product-select-option--3.variants__options .single-option-selector input[type=radio]').on('change', function() {

        showSelectedVariantDetails();

        const selectedValue = $(this).next('label').attr('data-value');


        $('.product-field.c_2 [id="stone-shape-details"]').each(function() {
           $(this).text(selectedValue);
        });
    });


    
    // function updateCombinedValues() {
    //     setTimeout(function() {
    //         const activeTable = $('.product-fields-table.v_act');
    //         const textC2 = activeTable.find('.product-field.c_2 span#stone-shape-details').text();
    //         const textC3 = activeTable.find('.product-field.c_3 span#stone-shape-details').text();
    //         const combinedText = textC2 + textC3;
    //         activeTable.find('.product-field.c_1 span#metal-color-details').text(combinedText);
    //     }, 300);
    // }

    function updateSku() {
        const selectedSku = $('select[name=id].product-single__variants').find('option:selected').data('sku');
        $('#sku-detailssss').text(selectedSku);
    }

   
    $(document).on('change', 'select[name=id].product-single__variants', function() {
        setTimeout(updateSku, 1000); 
    });

  $(document).on('click', '.single-option-selector label', function() {
         setTimeout(showSelectedVariantDetails, 1000); 
    });

    showSelectedVariantDetails();
    updateSku();
    // Listen for changes and update SKU after 2 seconds
  document.addEventListener("change", function (event) {
    setTimeout(function () {
      updateSku(); // Update after 2 seconds
    }, 1000);
  });
});


    function cs_toggleAccordion() {
      const content = document.getElementById('cs_accordionContent');
      const icon = document.getElementById('cs_accordionIcon');
      content.classList.toggle('open');
      if (content.classList.contains('open')) {
        icon.textContent = "-";
      } else {
        icon.textContent = "+";
      }
    }

// =============================== Variant Js


// Function to get URL parameters
function getUrlParameter(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

// Function to select the first variant if no variant is present in the URL
function selectFirstVariantIfNoVariantInURL() {
  const variantId = getUrlParameter('variant');

  if (!variantId) {
    // Select the first color option
    const firstColor = document.querySelector('.js-single-option-selector[name="option1"]');
    if (firstColor) {
      firstColor.checked = true;
      localStorage.setItem('selectedColor', firstColor.value);
    }

    // Select the first material option
    const firstMaterial = document.querySelector('.js-single-option-selector[name="option2"]');
    if (firstMaterial) {
      firstMaterial.checked = true;
      localStorage.setItem('selectedMaterial', firstMaterial.value);
    }
  }
}

// Function to update material options visibility based on color selection
function updateMaterialOptionsVisibility() {
  const selectedColor = localStorage.getItem('selectedColor');
  const selectedMaterial = localStorage.getItem('selectedMaterial');

  // Update material visibility
  document.querySelectorAll('.js-product-select-option--2 .single-option-selector').forEach(function (option) {
    const materialValue = option.querySelector('input').value;

    if (selectedColor === 'Platinum') {
      option.style.display = materialValue === 'PL' ? '' : 'none'; // Show only PL for Platinum
      if (materialValue === 'PL') {
        option.querySelector('input').checked = true; // Check PL
        localStorage.setItem('selectedMaterial', 'PL'); // Save PL as selected
      }
    } else {
      option.style.display = materialValue === 'PL' ? 'none' : ''; // Hide PL, show others

      // Check first visible material for non-Platinum
      if (!selectedMaterial || selectedMaterial === 'PL') {
        const firstVisibleMaterial = document.querySelector(
          '.js-product-select-option--2 .single-option-selector input:not([value="PL"]):not([style*="display: none"])'
        );
        if (firstVisibleMaterial) {
          firstVisibleMaterial.checked = true;
          localStorage.setItem('selectedMaterial', firstVisibleMaterial.value);
        }
      }
    }
  });

  // Restore selected color
  if (selectedColor) {
    const colorOption = document.querySelector(`input[name="option1"][value="${selectedColor}"]`);
    if (colorOption) colorOption.checked = true;
  }

  // Restore selected material
  if (selectedMaterial) {
    const materialOption = document.querySelector(`input[name="option2"][value="${selectedMaterial}"]`);
    if (materialOption) materialOption.checked = true;
  }
}

// Event listener for color option changes
document.querySelectorAll('.js-single-option-selector[name="option1"]').forEach(function (radio) {
  radio.addEventListener('change', function () {
    const selectedColor = document.querySelector('input[name="option1"]:checked').value;

    // Save selected color
    localStorage.setItem('selectedColor', selectedColor);

    // Reset material selection for Platinum
    if (selectedColor === 'Platinum') {
      localStorage.setItem('selectedMaterial', 'PL');
    }

    updateMaterialOptionsVisibility();
  });
});

// Event listener for material option changes
document.querySelectorAll('.js-single-option-selector[name="option2"]').forEach(function (radio) {
  radio.addEventListener('change', function () {
    const selectedMaterial = document.querySelector('input[name="option2"]:checked').value;
    localStorage.setItem('selectedMaterial', selectedMaterial);
  });
});

// Initialize visibility and select first variant if no variant in URL
window.addEventListener('load', function () {
  selectFirstVariantIfNoVariantInURL();
  updateMaterialOptionsVisibility();
});

//    $(document).on("click", ".filter-color .select-filter", function () { 
//     let c_type = $(this).attr("data-title"); 
//     let final_c_type = 'Color-' + c_type; 

//          localStorage.setItem("final_c_type", final_c_type);

//     setTimeout(function () {
//         $(".product-card__images img").hide();
//         $(".products__col").each(function () {
//             $(this).find(`.product-card__images img[alt='${final_c_type}']`).first().show(); 
//         });
//     }, 1500);
// });
//  $(document).on("click", ".filter-list .select-filter", function () {
//     let itm = localStorage.getItem("final_c_type");

//     setTimeout(function () {
//         $(".product-card__images img").hide();
//         $(".products__col").each(function () {
//             $(this).find(`.product-card__images img[alt='${itm}']`).first().show();
//         });
//     }, 1500);
// });

// $(document).ready(function () {
//     let itm = localStorage.getItem("final_c_type");
//     if (itm) {
//         setTimeout(function () {
//             $(".product-card__images img").hide();
//             $(".products__col").each(function () {
//                 $(this).find(`.product-card__images img[alt='${itm}']`).first().show();
//             });
//         }, 1500);
//     } 
// });




$(document).ready(function () {
    setTimeout(function () {
        $(".product-single .single-option-selector input[type=radio]:checked + label[data-color]").click();
    }, 1500); 
});




// =============================== Product Video Js

// Get the video element and controls
// const video = document.querySelector('video');
// const controls = document.querySelector('.plyr__controls');
// const playButton = document.querySelector('.plyr__control[data-plyr="play"]');

// // Add event listeners for video click and play button click
// playButton.addEventListener('click', () => {
//   video.play();
//   controls.style.display = 'none'; // Hide controls
// });

// video.addEventListener('click', () => {
//   if (video.paused) {
//     video.play();
//     controls.style.display = 'none'; // Hide controls
//   } else {
//     video.pause();
//     controls.style.display = 'flex'; // Show controls
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
    // Fix syntax error in the else condition
    let variantSelect = document.getElementById("variant-select");
    let videoContainer = document.querySelector(".variant-video-container");
    
    if (variantSelect) {
        variantSelect.addEventListener("change", function () {
            let selectedOption = this.options[this.selectedIndex];
            let newVideoUrl = selectedOption.getAttribute("data-video-url");
            
            if (newVideoUrl && newVideoUrl !== "") {
                let video = videoContainer.querySelector("video");
                if (video) {
                    let source = video.querySelector("source");
                    source.src = newVideoUrl;
                    video.load();
                    video.play();
                }
            }
        });
    }
});